<div class="rs-modal">
  <button type="button" class="rs-close" aria-label="Close" (click)="activeModal.dismiss('dismiss')">
    <svg width="13" height="13" viewBox="0 0 13 13" aria-hidden="true">
      <path d="M1 1l11 11M12 1L1 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    </svg>
  </button>

  <div class="rs-badge-wrap">
    <div class="rs-badge">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 21s-7-7.58-7-12a7 7 0 0 1 14 0c0 4.42-7 12-7 12z" />
        <circle cx="12" cy="9" r="2.5" />
      </svg>

      <div class="rs-flag" *ngIf="detectedCountryCode && !flagFailed">
        <img [src]="flagSrc" [alt]="detectedCountryName" (error)="flagFailed = true" />
      </div>
    </div>
  </div>

  <h2 class="rs-title">
    Switch to <span class="rs-title-standard">{{ detectedShortName }}</span>?
  </h2>

  <div class="rs-body">
    <p class="rs-body-line">
      You're currently viewing the <span class="rs-standard-name">{{ currentShortName }}</span>
      calculator.
    </p>
    <p class="rs-body-line">
      We've detected your location as: <strong>{{ detectedCountryName }}</strong>.
    </p>
    <p class="rs-body-line">
      Our <span class="rs-standard-name">{{ detectedShortName }}</span> calculator may better suit
      your needs.
    </p>
  </div>

  <div class="rs-actions">
    <button type="button" class="rs-btn rs-btn-primary" (click)="activeModal.close('switch')">
      Switch to {{ detectedShortName }}
    </button>

    <button type="button" class="rs-btn rs-btn-secondary" (click)="activeModal.dismiss('dismiss')">
      Continue with {{ currentShortName }}
    </button>
  </div>
</div>
